import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, createStyles } from '../../styles';
import InputHelperText from '../InputHelperText';
import InputLabel from '../InputLabel';
import Input from '../Input';
const useStyles = makeStyles((_) => createStyles({
    root: {
        width: '100%',
    },
}));
export const NumberField = ({ label, value = null, min = undefined, max = undefined, error = false, disabled = false, helperText = '', onChange = () => {
    return;
}, onBlur = () => {
    return;
}, }) => {
    const classes = useStyles();
    return (_jsxs("div", Object.assign({ className: classes.root }, { children: [_jsx(InputLabel, Object.assign({ error: error, disabled: disabled }, { children: label })), _jsx(Input, { type: "number", value: value !== null ? String(value) : '', onBlur: onBlur, onChange: (v) => onChange(parseInt(v, 10)), disabled: disabled, error: error, min: min, max: max }), helperText && (_jsx(InputHelperText, Object.assign({ indent: true, error: error, disabled: disabled }, { children: helperText })))] })));
};
export default NumberField;
//# sourceMappingURL=NumberField.js.map